import { appRoutes } from "Public/consts/appRoutes";
import qs from "qs";

export const ROUTE_MODULES_INDEX = "modules";
export const ROUTE_USERNAME_CHANGE_VERIFY = "username.change.verify";
export const ROUTE_CONFIRM_TWO_FACTOR_ENABLE = "confirm.enable.2fa";
export const ROUTE_CONFIRM_TWO_FACTOR_DISABLE = "confirm.disable.2fa";
export const ROUTE_MASTER_LOGIN = "master.login";
export const ROUTE_EXPERT_PROVIDER_MODULES_LIBRARY = "modules.library";
export const ROUTE_EXPERT_PROVIDER_MODULES_OTHER = "modules.other";
export const ROUTE_EXPERT_PROVIDER_MODULES_MY = "modules.my";
export const ROUTE_EXPERT_PROVIDER_MODULES_TEMPLATES = "modules.templates";

export const ROUTE_USER_MODULES_MY = "modules.user.my";
export const ROUTE_USER_MODULES_JOIN = "modules.user.join";

export const ROUTE_ARCHIVE_INDEX = "archive";
export const ROUTE_PROFILE_ONBOARDING = "profile.onboarding";

export const SETTINGS_PERMISSIONS_ROUTE = "settings.permissions";
export const SETTINGS_GENERAL_ROUTE = "settings.general";
export const SETTINGS_PERMISSIONS_USER_LIST_ROUTE =
  "settings.permissions.user.list";
export const SETTINGS_CONNECTIONS_ROUTE = "settings.connections";
export const SETTINGS_EXPERT_CONNECTIONS_ROUTE = "settings.expert.connections";

export const ROUTE_PARSE_SETTINGS_PERMISSIONS_USER_LIST = (tab, role = "") => {
  return {
    name: SETTINGS_PERMISSIONS_USER_LIST_ROUTE,
    params: { tab, role },
  };
};
export const SETTINGS_ADD_CONNECTION_ROUTE = "settings.add.connection";

export const ROUTE_PROFILE = "profile.show";

export const ROUTE_PROFILE_MY_USERS_LIST = "profile.show.my.users.list";

export const PARSE_ROUTE_PROFILE_USERS_LIST = (id, type) => ({
  name: ROUTE_PROFILE_MY_USERS_LIST,
  params: { id, type },
});

export const ROUTE_PARSE_PROFILE = (id) => {
  return {
    name: ROUTE_PROFILE,
    params: { id: id },
  };
};

export const ROUTE_GROUP_DETAILS = "group.show";

export const ROUTE_GROUP_REQUESTS = "social.group.requests";

export const ROUTE_FRIEND_REQUESTS = "social.friend.requests";

export const ROUTE_MODULE_GROUP_JOIN = "challenge.team.join";

export const ROUTE_LOGIN = "login";
export const ROUTE_RECOVER_USERNAME = "recover.username";
export const ROUTE_RECOVER_USERNAME_REVEAL = "recover.username.reveal";
export const ROUTE_RESET_PASSWORD = "reset.password";
export const ROUTE_RESET_PASSWORD_SUBMIT = "reset.password.submit";

export const ROUTE_APPROVE_INDEX = "approve";
export const ROUTE_APPROVE_USERS = {
  name: ROUTE_APPROVE_INDEX,
  params: { tab: "users" },
};

export const ROUTE_APPROVE_GROUPS = {
  name: ROUTE_APPROVE_INDEX,
  params: { tab: "groups" },
};

export const ROUTE_APPROVE_MODULES = {
  name: ROUTE_APPROVE_INDEX,
  params: { tab: "modules" },
};

export const ROUTE_MODULE_DETAILS = (id, params) => {
  const route = { name: "course.show", params: { challengeId: id } };
  if (params) Object.assign(route.params, params);
  return route;
};

export const ROUTE_MODULE_QR_CODE_JOIN_CONFIRM = "course.join.qr.code.confirm";

export const PARSE_ROUTE_MODULE_EDIT = (id) =>
  ROUTE_MODULE_DETAILS(id, { editMode: true });

export const ROUTE_CHAT_CONVERSATION = (id) => {
  return {
    name: "social.messages.chat.conversation",
    params: { conversationId: id },
  };
};

export const ROUTE_SOCIAL_FRIENDS_OF_USERS = "social.friends.of.users";

export const ROUTE_SOCIAL_FRIENDS_OF_FRIENDS = "social.friends.of.friends";

export const ROUTE_SOCIAL_EXPERTS = "social.experts";

export const ROUTE_SOCIAL_EXPERTS_INVITES = "social.experts.invites";

export const ROUTE_SOCIAL_EXPERTS_ACCESS_REQUESTS =
  "social.experts.access.requests";

export const ROUTE_APPROVE_STEPS = {
  name: ROUTE_APPROVE_INDEX,
  params: { tab: "steps" },
};

export const ROUTE_STEP_TEMPLATE_CREATE = "step.template.create";

export const ROUTE_STEP_TEMPLATE_LIBRARY = "step.template.library";

export const ROUTE_REWARD_DETAILS = "reward.show";

export const ROUTE_REWARD_DETAILS_CREATOR = (id) => {
  return {
    name: ROUTE_REWARD_DETAILS,
    params: { rewardId: id },
  };
};

export const ROUTE_NEW_EMAIL_VERIFICATION = "verification.new.email";

export const ROUTE_NEW_PASSWORD_VERIFICATION = "verification.new.password";

export const ROUTE_INDEX = "index";

export const ROUTE_TRAQ_DETAILS = "traq.show";

export const ROUTE_TRAQ_QR_CODE_JOIN_CONFIRM = "traq.qr.code.join.confirm";

export const ROUTE_TRAQING_EXPERT_PROVIDER = "traqing.expert.provider";

export const ROUTE_TRAQING_USER_REPORTS = "traqing.reports";

export const ROUTE_TRAQING_USER_REPORT = "traqing.report";

export const ROUTE_TRAQING_USER_STATUS = "traqing.status";

export const ROUTE_REWARDS_WON = "rewards.won";

export const ROUTE_REWARDS_LEADERBOARD = "rewards.leaderboard";

export const ROUTE_REWARDS_POTENTIAL = "rewards.potential";

export const ROUTE_PARSE_TRAQ_DETAILS = (id, params) => {
  const route = { name: ROUTE_TRAQ_DETAILS, params: { traqId: id } };
  if (params) Object.assign(route.params, params);
  return route;
};

export const PARSE_ROUTE_TRAQ_EDIT = (id) =>
  ROUTE_PARSE_TRAQ_DETAILS(id, { editMode: true });

export const ROUTE_MODULE_TEAM_JOIN = "challenge.team.join";

export const ROUTE_PARSE_MODULE_TEAM_JOIN = (id) => {
  return {
    name: ROUTE_MODULE_TEAM_JOIN,
    params: { challengeId: id },
  };
};

export const ROUTE_MODULE_INVITE_USERS = "challenges.invite.participants";

export const ROUTE_PARSE_MODULE_INVITE_USERS = (id) => {
  return {
    name: ROUTE_MODULE_INVITE_USERS,
    params: { challengeId: id },
  };
};

export const ROUTE_CATEGORIES_MANAGEMENT = "categories";

export const ROUTE_CATEGORY_CREATE = "categories.create";

export const ROUTE_CATEGORY_EDIT = "categories.edit";

export const ROUTE_PARSE_CATEGORY_EDIT = (id) => {
  return {
    name: ROUTE_CATEGORY_EDIT,
    params: { id: id },
  };
};

export const ROUTE_SUBCATEGORIES_CREATE = "subcategories.create";

export const ROUTE_PARSE_SUBCATEGORIES_CREATE = (categoryId) => {
  return {
    name: ROUTE_SUBCATEGORIES_CREATE,
    params: { categoryId: categoryId },
  };
};

export const ROUTE_SUBCATEGORY_EDIT = "subcategories.edit";

export const ROUTE_PARSE_SUBCATEGORY_EDIT = (id, category_id) => {
  return {
    name: ROUTE_SUBCATEGORY_EDIT,
    params: { id: id, categoryId: category_id },
  };
};

export const ROUTE_PARSE_GROUP_DETAILS = (id) => {
  return {
    name: ROUTE_GROUP_DETAILS,
    params: { groupId: id },
  };
};

export const ROUTE_GROUP_MEMBERS = "group.member.management";

export const ROUTE_PARSE_GROUP_MEMBERS_INVITE = (id) => {
  return {
    name: ROUTE_GROUP_MEMBERS,
    params: { groupId: id, tab: "invite" },
  };
};

export const ROUTE_PARSE_GROUP_MEMBERS_TAB = (id) => {
  return {
    name: ROUTE_GROUP_MEMBERS,
    params: { groupId: id },
  };
};

export const ROUTE_GROUP_MODULES = "group.module.management";

export const ROUTE_PARSE_GROUP_MODULES = (id) => {
  return {
    name: ROUTE_GROUP_MODULES,
    params: { groupId: id },
  };
};

export const ROUTE_PARSE_GROUP_SUGGEST_MODULE = (id) => {
  return {
    name: ROUTE_GROUP_MODULES,
    params: { groupId: id, tab: "suggest" },
  };
};

export const ROUTE_STEP_DETAILS = "steps.show";

export const ROUTE_PARSE_STEP_DETAILS = (
  moduleId,
  stepId,
  userId = undefined
) => {
  return {
    name: ROUTE_STEP_DETAILS,
    params: { challengeId: moduleId, stepId, userId },
  };
};

export const ROUTE_MODULE_LEADERBOARDS = "module.leaderboards";

export const ROUTE_PARSE_MODULE_LEADERBOARDS = (id) => {
  return {
    name: ROUTE_MODULE_LEADERBOARDS,
    params: { moduleId: id },
  };
};

export const ROUTE_PARSE_MODULE_GROUP_INTRATEAM_LEADERBOARD = (
  moduleId,
  groupId
) => {
  return {
    name: ROUTE_MODULE_LEADERBOARDS,
    params: { moduleId: moduleId, groupId: groupId, tab: "my groups" },
  };
};

export const ROUTE_SOCIAL = "social";

export const ROUTE_SOCIAL_FRIENDS = "social.friends";

export const ROUTE_SOCIAL_FRIENDS_TAB = {
  name: ROUTE_SOCIAL_FRIENDS,
};

export const ROUTE_SOCIAL_USERS = "social.users";

export const ROUTE_SOCIAL_USERS_TAB = {
  name: ROUTE_SOCIAL_USERS,
};

export const ROUTE_SOCIAL_GROUPS = "social.groups";

export const ROUTE_SOCIAL_GROUPS_TAB = {
  name: ROUTE_SOCIAL_GROUPS,
};

export const ROUTE_SOCIAL_MESSAGES = "social.messages";

export const ROUTE_SOCIAL_MESSAGES_TAB = {
  name: ROUTE_SOCIAL_MESSAGES,
};

export const ROUTE_MODULE_USER_LIST = "module.user.list";
export const ROUTE_MODULE_USER_LIST_USERS = "module.user.list.users";
export const ROUTE_MODULE_USER_LIST_GROUPS = "module.user.list.groups";
export const ROUTE_MODULE_USER_LIST_PARTICIPANTS =
  "module.user.list.participants";
export const ROUTE_MODULE_USER_LIST_APPROVERS = "module.user.list.approvers";
export const ROUTE_MODULE_USER_LIST_EXPERTS = "module.user.list.experts";

export const ROUTE_PARSE_MODULE_USER_USERS_LIST = (id) => {
  return {
    name: ROUTE_MODULE_USER_LIST_USERS,
    params: { tab: "users", id: id },
  };
};

export const ROUTE_PARSE_MODULE_USER_EXPERTS_LIST = (id) => {
  return {
    name: ROUTE_MODULE_USER_LIST_EXPERTS,
    params: { tab: "experts", id: id },
  };
};

export const ROUTE_PARSE_MODULE_USER_APPROVERS_LIST = (id) => {
  return {
    name: ROUTE_MODULE_USER_LIST_APPROVERS,
    params: { tab: "approvers", id: id },
  };
};

export const ROUTE_PARSE_MODULE_USER_GROUPS_LIST = (id) => {
  return {
    name: ROUTE_MODULE_USER_LIST_GROUPS,
    params: { tab: "groups", id: id },
  };
};

export const ROUTE_PARSE_MODULE_USER_PARTICIPANTS_LIST = (id) => {
  return {
    name: ROUTE_MODULE_USER_LIST_PARTICIPANTS,
    params: { tab: "participants", id: id },
  };
};

export const ROUTE_TRAQ_USER_LIST = "traq.user.list";
export const ROUTE_TRAQ_USER_LIST_USERS = "traq.user.list.users";
export const ROUTE_TRAQ_USER_LIST_PARTICIPANTS = "traq.user.list.participants";
export const ROUTE_TRAQ_USER_LIST_EXPERTS = "traq.user.list.experts";
export const ROUTE_TRAQ_USER_LIST_APPROVERS = "traq.user.list.approvers";

export const ROUTE_PARSE_TRAQ_USERS_LIST = (id) => {
  return {
    name: ROUTE_TRAQ_USER_LIST_USERS,
    params: { tab: "users", id: id },
  };
};

export const ROUTE_PARSE_TRAQ_PARTICIPANTS_LIST = (id) => {
  return {
    name: ROUTE_TRAQ_USER_LIST_PARTICIPANTS,
    params: { tab: "participants", id: id },
  };
};

export const ROUTE_PARSE_TRAQ_EXPERTS_LIST = (id) => {
  return {
    name: ROUTE_TRAQ_USER_LIST_EXPERTS,
    params: { tab: "experts", id: id },
  };
};

export const ROUTE_PARSE_TRAQ_APPROVERS_LIST = (id) => {
  return {
    name: ROUTE_TRAQ_USER_LIST_APPROVERS,
    params: { tab: "approvers", id: id },
  };
};

export const ROUTE_EXPERT_REQUESTS = "social.expert.requests";

export const ROUTE_MODULE_JOIN_REQUESTS = "social.module.join.requests";

export const ROUTE_USER_REQUESTS = "social.user.requests";

export const ROUTE_TRAQ_INVITE_USERS = "traq.invite.participants";

export const ROUTE_PARSE_TRAQ_INVITE_USERS = (id) => {
  return {
    name: ROUTE_TRAQ_INVITE_USERS,
    params: { traqId: id },
  };
};

export const ROUTE_MANAGE_EXPERT_CONNECTIONS =
  "settings.expert.module.connections";

export const ROUTE_PARSE_MANAGE_EXPERT_CONNECTIONS = (id, moduleId) => {
  return {
    name: ROUTE_MANAGE_EXPERT_CONNECTIONS,
    params: { expertId: id, moduleId: moduleId },
  };
};

export const ROUTE_APPROVE_STEPS_NAME = "approve.steps";

export const ROUTE_PARSE_APPROVE_STEPS_SEARCH = (search) => {
  return {
    name: ROUTE_APPROVE_STEPS_NAME,
    params: {
      search,
    },
  };
};

export const ROUTE_APPROVE_MODULES_NAME = "approve.modules";

export const ROUTE_PARSE_APPROVE_MODULE_SEARCH = (search) => ({
  name: ROUTE_APPROVE_MODULES_NAME,
  params: {
    search,
  },
});

export const ROUTE_PROTECTED_FILE_DOWNLOAD = "protected.file";

export const ROUTE_CONTENT_REPORT_LIST = "content.report.list";

export const ROUTE_ACCOUNTS_LIST = "accounts.list";
export const ROUTE_ACCOUNT_DETAILS = "accounts.details";

export const ROUTE_MEDIA_STORAGE = "media.storage";
export const ROUTE_QR_CODE_SETTINGS = "qr.code.settings";

export const ROUTE_QR_CODE_DO_STEP_CONFIRMATION = "qr.do.step.confirmation";

export const ROUTE_STEP_UNDO_REQUESTS = "step.undo.requests";

export const ROUTE_PARSE_MODULE_TRAQING_REPORT = (
  moduleId,
  userId = undefined,
  config = {}
) => {
  const { urlParams } = config;
  const baseRoute = appRoutes.traqingReport(moduleId, userId);
  if (urlParams) {
    const params = qs.stringify(urlParams);
    return `${baseRoute}?${params}`;
  }
  return baseRoute;
};
